import { IsEllipsisDirective } from '@agilox/directive/is-ellipsis';
import { Component, input } from '@angular/core';
import { TooltipModule } from '../tooltip/tooltip.module';

@Component({
	selector: 'ui-table-header-label',
	imports: [IsEllipsisDirective, TooltipModule],
	templateUrl: './table-header-label.component.html',
})
export class TableHeaderLabelComponent {
	label = input<string>('');
	styleClass = input<string>('');
}
